import { useRef } from "react";
import gsap from "gsap";
import { useGSAP } from "@gsap/react";
import { ScrollTrigger } from "gsap/all";

import { counterItems } from "../../constants";

gsap.registerPlugin(ScrollTrigger);

const Numbers = () => {
  const counterRef = useRef(null);
  const countersRef = useRef([]);

  useGSAP(() => {
    countersRef.current.forEach((counter, index) => {
      const numberElement = counter.querySelector(".counter-number");
      const item = counterItems[index];

      // Set initial value to 0
      gsap.set(numberElement, { innerText: "0" });

      // Create the counting animation
      gsap.to(numberElement, {
        innerText: item.value,
        duration: 2.5,
        ease: "power2.out",
        snap: { innerText: 1 }, // Ensures whole numbers
        scrollTrigger: {
          trigger: "#counter",
          start: "top center",
        },
        // Add the suffix after counting is complete
        onComplete: () => {
          numberElement.textContent = `${item.value}${item.suffix}`;
        },
      });
    }, counterRef);
  }, []);

  return (
    <div
      id="counter"
      ref={counterRef}
      className="px-10 py-14 lg:py-8 bg-[#0d1821]"
    >
      <div className="mx-auto grid grid-cols-1 lg:grid-cols-4 gap-3 lg:gap-3">
        {counterItems.map((item, index) => (
          <div
            key={index}
            ref={(el) => el && (countersRef.current[index] = el)}
            className="bg-[#0d1821] rounded-lg p-3 flex flex-col justify-center lg:justify-around lg:items-center"
          >
            <div className="counter-number text-[#f5f5f5] text-4xl lg:text-5xl mb-2 font-[600]">
              0 {item.suffix}
            </div>
            <div className="text-[#f5f5f5] text-md md:text-lg font-poppins font-[400]">
              {item.label}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Numbers;
